import { render, staticRenderFns } from "./NewbieLessonManagement.vue?vue&type=template&id=26be988c&scoped=true"
import script from "./NewbieLessonManagement.vue?vue&type=script&lang=js"
export * from "./NewbieLessonManagement.vue?vue&type=script&lang=js"
import style0 from "./NewbieLessonManagement.vue?vue&type=style&index=0&id=26be988c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be988c",
  null
  
)

export default component.exports